<template>
  <el-dialog
    top="10vh"
    :title="$t('Common.detail')"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="close"
    :visible.sync="visible"
  >
    <Description>
      <DescriptionItem :span="24" labelWidth="90px" :label="$t('Fota.firmwareName')">{{
        row.name | format
      }}</DescriptionItem>
      <!--      <DescriptionItem :span="24" labelWidth="90px" label="PRODUCTID">{{-->
      <!--        row.creatorId | format-->
      <!--      }}</DescriptionItem>-->
      <DescriptionItem :span="24" labelWidth="90px" label="KEY">{{
        row.signKey | format
      }}</DescriptionItem>
      <DescriptionItem :span="24" labelWidth="90px" :label="$t('Fota.updateType')"
        >http</DescriptionItem
      >
      <DescriptionItem :span="24" labelWidth="90px" :label="$t('Fota.firmwareModel')">{{
        row.productModel | format
      }}</DescriptionItem>
      <DescriptionItem :span="24" labelWidth="90px" :label="$t('Device.productName')">{{
        row.productKeyName | format
      }}</DescriptionItem>
      <!--      <DescriptionItem :span="24" labelWidth="90px" :label="$t('Fota.hardwareModel')">{{-->
      <!--        row.hardwareModel | format-->
      <!--      }}</DescriptionItem>-->
      <DescriptionItem :span="24" labelWidth="90px" :label="$t('Fota.remark')">{{
        row.remark | format
      }}</DescriptionItem>
    </Description>
  </el-dialog>
</template>

<script>
import Description from '@/components/Descriptions'
import DescriptionItem from '@/components/Descriptions/DescriptionsItem'

import { format } from '@/utils/utils'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: Object
  },
  components: {
    Description,
    DescriptionItem
  },
  data() {
    return {}
  },
  filters: {
    format(val) {
      return format(val)
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss"></style>
